<template>
  <img
    :src="src"
    :alt="altText"
    :width="width"
    :height="height"
    class="bank-image"
    v-bind="$attrs"
    v-on="$listeners"
  >
</template>

<script>
import bankList from '@g/data/bankList'

const BANK_IMAGE_BASE = 'https://static.kkren.com.tw/static/images/bank'

function getBankCodes (type) {
  return new Set(Object.values(bankList[type] || {}).map(item => item.split(' ')[0]))
}

const peasantAssociationCodes = getBankCodes('peasant_association')
const fishermanAssociationCodes = getBankCodes('fisherman_association')
const defaultBankImageCodes = new Set(['600'])

export default {
  inheritAttrs: false,
  props: {
    bank: {
      type: String,
      default: '',
    },
    code: {
      type: [String, Number],
      default: '',
    },
    width: {
      type: [String, Number],
      default: 40,
    },
    height: {
      type: [String, Number],
      default: null,
    },
    alt: {
      type: String,
      default: '',
    },
  },
  computed: {
    bankCode () {
      const code = this.code || this.bank.split(' ')[0]
      const text = `${code || ''}`.trim()

      if (!text) return ''

      return text.padStart(3, '0')
    },
    src () {
      if (!this.bankCode) return ''

      if (defaultBankImageCodes.has(this.bankCode)) {
        return `${BANK_IMAGE_BASE}/bank-${this.bankCode}.png`
      }

      if (peasantAssociationCodes.has(this.bankCode)) {
        return `${BANK_IMAGE_BASE}/nonghui.jpeg`
      }

      if (fishermanAssociationCodes.has(this.bankCode)) {
        return `${BANK_IMAGE_BASE}/yuhui.jpeg`
      }

      return `${BANK_IMAGE_BASE}/bank-${this.bankCode}.png`
    },
    altText () {
      if (this.alt) return this.alt
      if (this.bank) return this.bank
      if (this.bankCode) return `${this.bankCode} 銀行`
      return '銀行圖片'
    },
  },
}
</script>

<style lang="postcss" scoped>
.bank-image {
  object-fit: contain;
  vertical-align: middle;
}
</style>
